// extracted by mini-css-extract-plugin
module.exports = {"container":"PaginationBar_container__3H10S","next":"PaginationBar_next__1R-BH","active":"PaginationBar_active__3jTGm"};